import { createApp } from 'vue'
import {
  ElAlert,
  ElBadge,
  ElButton,
  ElCheckbox,
  ElConfigProvider,
  ElDatePicker,
  ElDialog,
  ElDrawer,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElEmpty,
  ElForm,
  ElFormItem,
  ElIcon,
  ElInput,
  ElInputNumber,
  ElLoading,
  ElMenu,
  ElMenuItem,
  ElOption,
  ElPagination,
  ElSelect,
  ElTable,
  ElTableColumn,
  ElTabPane,
  ElTabs,
  ElTag,
  ElTimeline,
  ElTimelineItem,
  ElTooltip,
  ElUpload,
} from 'element-plus'

import App from './App.vue'
import { pinia } from './stores'
import { router } from './router'
import 'element-plus/dist/index.css'
import './styles/main.css'

const app = createApp(App)

const uiComponents = [
  ElAlert,
  ElBadge,
  ElButton,
  ElCheckbox,
  ElConfigProvider,
  ElDatePicker,
  ElDialog,
  ElDrawer,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElEmpty,
  ElForm,
  ElFormItem,
  ElIcon,
  ElInput,
  ElInputNumber,
  ElMenu,
  ElMenuItem,
  ElOption,
  ElPagination,
  ElSelect,
  ElTable,
  ElTableColumn,
  ElTabPane,
  ElTabs,
  ElTag,
  ElTimeline,
  ElTimelineItem,
  ElTooltip,
  ElUpload,
]

uiComponents.forEach((component) => app.use(component))
app.use(ElLoading)
app.use(pinia).use(router).mount('#app')
